<div
  class="sp-select-widget"
  [ngClass]="['sp-select', size, status, searchFieldLike, showBorder ? 'border' : '', required && !selected ? 'error' : '']"
  [class.searchBox]="searchBox"
>
  <div class="sp-select-container inside tooltip-default has-tooltip">
    <span class="sp-select-container-tooltip tooltip tooltip--bottom" *ngIf="showTooltip">
      <ng-template [ngIf]="!multiple" class="sp-select-container-tooltip-item">{{ getLabelForSelectedItem(selected) }}</ng-template>
      <ng-template [ngIf]="multiple && selected.length">
        <ng-template ngFor let-item [ngForOf]="selected">
          <label class="sp-select-container-tooltip-item" *ngIf="item !== ''">{{ getLabelForSelectedItem(item) }}</label>
        </ng-template>
      </ng-template>
    </span>
    <!-- <label class="title-label">type something</label> -->
    <ng-select
      #api
      (blur)="emitOnBlur()"
      [placeholder]="placeholder"
      [searchable]="searchable"
      [closeOnSelect]="closeOnSelect"
      (change)="propagateChange($event)"
      [bindLabel]="bindLabel"
      [bindValue]="bindValue"
      [items]="items"
      [multiple]="multiple"
      [addTag]="addTag"
      [typeahead]="typeahead"
      [(ngModel)]="selected"
      [groupBy]="groupBy"
      [loading]="loading"
      [loadingText]="loadingText"
      [notFoundText]="notFoundText"
      [typeToSearchText]="typeToSearchText"
      [addTagText]="addTagText"
      [disabled]="disabled"
    >
      <ng-template ng-label-tmp *ngIf="multiple">
        <span class="ng-value-icon left" (click)="clearSelected()" aria-hidden="true">×</span>
        {{ count }} من - {{ multiple_text || placeholder }}
       </ng-template>
      <ng-template ng-header-tmp>
        <div *ngIf="searchBox" class="search-widget">
          <sp-icon *ngIf="icon" class="icon icon-left" size="small" [inherit]="true" [name]="icon" type="solid"></sp-icon>
          <input
            #searchBoxInput
            type="text"
            class="data-hj-whitelist"
            (input)="api.filter($any($event.target).value)"
            [placeholder]="typeToSearchText"
          />
        </div>
        <div class="sp-clearfix search-widget-count" *ngIf="multiple && count">
          <span class="search-widget-count-clear" (click)="clearSelected()">x</span> {{ count }}
        </div>
      </ng-template>
      <ng-template *ngIf="checkBox" ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <sp-icon
          *ngIf="item$.value.icon"
          class="icon icon-left"
          size="small"
          [inherit]="true"
          [name]="item$.value.icon"
          type="solid"
        ></sp-icon>
        {{ item[bindLabel] }}
        <div class="checkbox-widget">
          <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> <span class="checkmark"></span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <span [title]="item[bindLabel]" *ngIf="extraIntent">{{ item[bindLabel].replace(extraIntent, '') }} </span>
        <span [title]="item[bindLabel]" *ngIf="!extraIntent">{{ item[bindLabel] }} </span>
        <span *ngIf="parentLabel" class="category-label" (click)="clickedParent($event, item)">{{ item[parentLabel] }}</span>
      </ng-template>
    </ng-select>
  </div>
  <span class="underline-text" *ngIf="warning">{{ warning }}</span>
  <select name="sp-select" id="mobileselect" *ngIf="isMobile" (change)="changedSelect($event)">
    <option
      *ngFor="let item of items"
      [value]="item[bindValue]"
      [selected]="selected && (selected === item[bindValue] || selected[bindValue] === item[bindValue])"
      >{{ item[bindLabel] }}</option
    >
  </select>

  <div *ngIf="showOverlay" class="select-overlay" (click)="hideOverlay()"></div>
</div>
